import React, { Component } from 'react';
import '../../assets/scss/style.scss';
import data from '../../json/regisComp.json';

class Instruction extends Component {
    render() {
        return(
            <div className="container">
              <h3>Step 1 : Tentang {data[this.props.type]?.text}</h3>
              <hr/>
              Syarat: <br/>
              {data.syarat.map((p, i) =>
                <div key={i}>&nbsp;&nbsp;&nbsp;&nbsp;{p}<br/></div>
              )}
              <br/>
              Harga: <br/>
              {data[this.props.type]?.harga.map((p, i) =>
                <div key={i}>&nbsp;&nbsp;&nbsp;&nbsp;{p}<br/></div>
              )}
              <br/>
              <b>
                {data.promo.syarat}
                <br/>
                Twibbon : &nbsp;<a href={data.promo.twibbon} style={{color:"blue"}}><u>{data.promo.twibbon}</u></a>
                <br/>
                {data.promo.instruksi}
              </b><br/>
              <br/>
              Langkah Lomba:<br/>
              {data.langkah.map((p, i) =>
                <div key={i}>&nbsp;&nbsp;&nbsp;&nbsp;{p}<br/></div>
              )}
              <button className="btn btn-primary btn-block mt-3 shadow-sm" onClick={this.props.nextStep}>Selanjutnya</button>
            </div>
        )
    }
}

export default Instruction;
